import { Button } from '@/components/elements/forms/buttons';
import useMobileView from '@/hooks/useMobileView';
import React from 'react';
import Modal from './redesign/Modal/Modal';

interface ConfirmationModalViewProps {
  isOpen: boolean;
  title?: string;
  subTitle?: string;
  body?: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
}

const ConfirmationModalView: React.FC<ConfirmationModalViewProps> = ({
  isOpen,
  title,
  subTitle,
  body,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  isLoading,
}) => {
  const { isMobileView } = useMobileView();

  return (
    <Modal className={`${isMobileView ? 'h-screen' : 'md:max-w-[560px]'}`} isOpen={isOpen} onRequestClose={onCancel}>
      <Modal.Content newDesign={true} contentPadding={false} floating={!isMobileView}>
        <Modal.Header newDesign={true} title={title} floating={!isMobileView} onClose={onCancel} />
        <div className={`p-xl gap-xs bg-surface_l4 flex h-full flex-col ${isMobileView ? 'flex-1' : 'rounded-b-lg'}`}>
          <h2 className="text-h-s">{subTitle}</h2>
          {body}
        </div>
        <div
          className={`bg-surface_l4 p-md border-border_regular flex justify-between border-t ${
            isMobileView ? '' : 'rounded-b-lg'
          }`}>
          <Button label={cancelText} variant="link" size="md" onClick={onCancel} />

          <div className="gap-md flex">
            <Button label={confirmText} loading={isLoading} size="md" onClick={onConfirm} />
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default ConfirmationModalView;
